import { FC, useState, useEffect } from 'react'
import s from './index.module.less'
import { Modal } from 'antd'
interface Props {
  visible: boolean
}
const LoginGoodModal: FC<Props> = (props) => {
  const { visible } = props
  const [open, setOpen] = useState(false)
  useEffect(() => { setOpen(visible) }, [visible])
  const handleClose = () => setOpen(false)
  return (
    <Modal wrapClassName={s.modal} open={open} onCancel={handleClose} 
    centered destroyOnClose={true} closable={false} 
    footer={null} mask={false} maskClosable={true}>
      <div className={s.root}>
        <div className='closeBtn' onClick={handleClose}>
          <i className='iconfont icon-lujing3'></i>
        </div>
        <div className="footer">
            <div className='btn' onClick={handleClose}>立即使用</div>
        </div>
      </div>
    </Modal>
  )
}
export default LoginGoodModal
